import { doc } from "prettier";

enum VIDEO_PROVIDERS {
    YOUTUBE = "youtube",
    VIMEO = "vimeo",
}

const queryParamDictionary: {
    [key: string]: { name: string; value: string }[];
} = {};
queryParamDictionary[VIDEO_PROVIDERS.YOUTUBE] = [
    { name: "enablejsapi", value: "1" },
    { name: "autoplay", value: "1" },
];
queryParamDictionary[VIDEO_PROVIDERS.VIMEO] = [
    { name: "enablejsapi", value: "1" },
    { name: "autoplay", value: "1" },
];


export const jobAlertVideoHandler = () => {
    const playButtons = document.querySelectorAll<HTMLButtonElement>(".job-details-video-banner__play-button");

    playButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
            const parentdiv =  button.closest<HTMLDivElement>(".job-details-video-banner");
            if (!parentdiv) {
                return;
            }
            
            const modal = parentdiv.querySelector<HTMLDialogElement>(".job-details-video-banner__video-modal");

            const videoSrc = getVideoSrc(parentdiv);

            const iframe = parentdiv.querySelector<HTMLIFrameElement>("iframe");
            if (!iframe) {
                return;
            }
            
            iframe.setAttribute("data-src", videoSrc || "");

            const formattedUrl = formatVideoUrl(videoSrc);

            modal?.showModal();

            document.body.classList.add("modal-open");

             updateIframeUrl(parentdiv, formattedUrl);
            
        });
    });
}

export const closeModalHandler = () => {
    const modal = document.querySelector<HTMLDialogElement>(".job-details-video-banner__video-modal");

    if (!modal) {
        return;
    }

    const closeButton = modal.querySelector<HTMLButtonElement>(".job-details-video-banner__close-button");

    closeButton?.addEventListener("click", () => {
        modal.close();
        const iframe = modal.querySelector<HTMLIFrameElement>("iframe");
        if (iframe) {
            iframe.setAttribute("src", "");
            document.body.classList.remove("modal-open");
        }
    })

    document.body.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            
            const iframe = modal.querySelector<HTMLIFrameElement>("iframe");
            if (iframe) {
                iframe.setAttribute("src", "");
                document.body.classList.remove("modal-open");
            }
            modal.close();
        }
    })

}

const getVideoSrc = (root) => {
    const iframe = root.querySelector("iframe");
    const videoSrc = oneTrustCheck(iframe);
    return videoSrc;
};


const oneTrustCheck = (iframe: HTMLIFrameElement) => {
    if (iframe.attributes["data-src"] !== undefined) {
        return iframe.getAttribute("data-src");
    }

    return iframe.getAttribute("src");
};

const formatVideoUrl = (videoSrc) => {
    const newSrc = new URL(videoSrc);

    const provider = getVideoProvider(videoSrc);
    if (provider) {
        const qparams = queryParamDictionary[provider];
        qparams.forEach((p) =>
            newSrc.searchParams.append(p.name, p.value.toString())
        );
    }

    return newSrc.href;
};


const getVideoProvider = (src: string) => {
    for (let provider in VIDEO_PROVIDERS) {
        if (src.includes(VIDEO_PROVIDERS[provider])) {
            return VIDEO_PROVIDERS[provider];
        }
    }
    return null;
};

const updateIframeUrl = (root, newSrc) => {
    const iframe = root.querySelector("iframe");
    iframe.setAttribute("src", newSrc);
};